import { useState, useRef, useEffect } from "react";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "../lib/i18n";
import { FLAGS } from "../lib/i18n_app";
import { useLang } from "../context/LanguageContext";

export default function LanguageSwitcher({ compact = false }) {
  const { lang, setLang } = useLang();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)} data-testid="lang-switcher"
        className="inline-flex items-center gap-1.5 border border-white/15 px-2.5 py-2 text-sm text-white transition-all hover:-translate-y-0.5 hover:border-cyan"
      >
        <span className="text-base leading-none">{FLAGS[current.code]}</span>
        {!compact && <span className="hidden text-xs uppercase sm:inline">{current.code}</span>}
        <Globe size={14} className="text-cyan" />
      </button>
      {open && (
        <div className="absolute right-0 top-12 z-[60] max-h-80 w-52 overflow-y-auto border border-white/10 bg-elevated shadow-2xl no-scrollbar" data-testid="lang-menu">
          {LANGUAGES.map((l) => (
            <button
              key={l.code} onClick={() => { setLang(l.code); setOpen(false); }} data-testid={`lang-option-${l.code}`}
              className={`flex w-full items-center gap-3 px-4 py-2.5 text-left text-sm transition-colors hover:bg-white/5 ${lang === l.code ? "text-cyan" : "text-ink-secondary"}`}
            >
              <span className="text-base leading-none">{FLAGS[l.code]}</span>
              <span className="flex-1">{l.label}</span>
              {lang === l.code && <Check size={14} className="text-cyan" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
